
var ddate = new Date();
var ihours = ddate.getHours();
setTimeout(function () {
if(ihours>=17){
  wholemessage = "<div class='announcement-bar__message'>ORDER NOW FOR DISPATCH TOMORROW MORNING</div>";
  if(iweek==5){wholemessage = "<div class='announcement-bar__message'>FREE UK MAINLAND DELIVERY ON ORDERS OVER £69</div>";}
  if(iweek==4){wholemessage = "<div class='announcement-bar__message'>FREE UK MAINLAND DELIVERY ON ORDERS OVER £69</div>";}

      if(iweek==6){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}
      if(iweek==0){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}

      if(iweek==1){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}
  
        

  document.getElementById("countdown-clock").innerHTML = wholemessage;
  throw new Error();
}
if(ihours>=14){
  wholemessage = "<div class='announcement-bar__message'>FREE UK MAINLAND DELIVERY ON ORDERS OVER £69</div>";
  document.getElementById("countdown-clock").innerHTML = wholemessage;
  throw new Error("Past 14h");
}
}, 2000);

var iyear = ddate.getFullYear();
var imonth = ddate.getMonth(); imonth++;
var iday = ddate.getDate();
var iweek =ddate.getDay();
var iminutes = ddate.getMinutes();


if(ihours<14){
  CountDownTimer(imonth + "/" + iday + "/" + iyear + " 2:00 PM", "countdown-clock");
  
  function CountDownTimer(dt, id) {
      var end = new Date(dt);
      var _second = 1000;
      var _minute = _second * 60;
      var _hour = _minute * 60;
      var _day = _hour * 24;
      var timer;
      var endmessage = " FOR SAME DAY DISPATCH";
    

      function showRemaining() {
       
          var now = new Date();
          var distance = end - now;

          if (distance < 0) {
              clearInterval(timer);
              var hours   = 23 - (Math.floor((-distance % _day) / _hour));
              var minutes = 59 - (Math.floor((-distance % _hour) / _minute));
              var seconds = 59 - (Math.floor((-distance % _minute) / _second));
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              return;
          }
        
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % _day) / _hour);
          var minutes = Math.floor((distance % _hour) / _minute);
          var seconds = Math.floor((distance % _minute) / _second);
        
          var wholemessage = "Order in the next";
  
          if (hours != 0) {
            if (hours >= 10) {
              wholemessage += " " + hours + " hours";
            }

            if (hours < 10 && hours > 1){
              wholemessage += " " + hours + " hours";
            }
            
            if (hours == 1){
              wholemessage += " 1 hour";
            }
          }
        
          if (minutes >= 10) {
            wholemessage += " " + minutes + " minutes";
          }
        
          if (minutes < 10 && minutes > 1) {
            wholemessage += " " + minutes + " minutes";
          }
        
          if (minutes == 1) {
            wholemessage += " " + minutes + " minute";
          }
        
          if (minutes == 0) {
            wholemessage += " " + minutes + " minutes";
          }                
        
  

         if(iweek==5){
                wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";
          }

        if(iweek==6){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}
        if(iweek==0){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}

        if(iweek==1){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}
        if(iweek==2){  wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";}
        wholemessage = "<div class='announcement-bar__message'>FREE UK DELIVERY ON ORDERS OVER £69</div>"; endmessage = "";
        finalmessage = "<div class='announcement-bar__message'>"+wholemessage+" "+endmessage+"</div>";                   
                              
        document.getElementById(id).innerHTML = finalmessage;
        timer = setInterval(showRemaining, 60*1000);
      }
    showRemaining();      
  }
}